import { VariaveisAmbiente } from "config";
import { useApiBase } from "data/api/base";
import { BoletoGetModel } from "model/api/gestao/boleto/boleto-get-model";
import { useCallback } from "react";
import { useSessaoAtual } from "services/app";

export function usePutCancelarBoleto() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<BoletoGetModel>();
    const { getEmpresa } = useSessaoAtual()

    const putCancelarBoleto = useCallback(
        (id: string) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/boleto/${id}/cancelar`,
                enviarTokenUsuario: true,
            })
        , [getEmpresa, invocarApi]
    )

    return {
        putCancelarBoleto,
        ...outrasPropriedades
    }

}
